import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/lib/queryKeys'
import { getCalendarGrid } from '@/api/calendars'
import type { CalendarGridResponse } from '@/types'

export function useCalendarGrid(calendarId: string | undefined) {
  return useQuery<CalendarGridResponse>({
    queryKey: queryKeys.calendars.grid(calendarId ?? ''),
    queryFn: () => getCalendarGrid(calendarId!),
    enabled: !!calendarId,
    staleTime: 1000 * 30,
  })
}
